"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var hook_1 = require("./hook");
var utils_1 = require("../utils");
function TabPane(props) {
    var _a = props.autoDestroy, autoDestroy = _a === void 0 ? false : _a, className = props.className, value = props.value, children = props.children, style = props.style;
    var _b = hook_1.useTabs(), prefix = _b.prefix, activeValue = _b.value;
    var _c = react_1.useState(activeValue === value), shown = _c[0], setShown = _c[1];
    var tabPanePrefix = utils_1.concat(prefix, 'pane');
    var classname = classnames_1.default(className, tabPanePrefix);
    react_1.useEffect(function () {
        if (activeValue === value && shown === false) {
            setShown(true);
        }
    }, [activeValue, shown, value]);
    if (autoDestroy) {
        if (activeValue === value) {
            return react_1.default.createElement("div", { className: classname, style: style }, children);
        }
        return null;
    }
    return react_1.default.createElement("div", { className: classname, style: tslib_1.__assign(tslib_1.__assign({}, style), { display: activeValue === value ? 'block' : 'none' }) }, shown ? children : null);
}
exports.default = TabPane;
//# sourceMappingURL=TabPane.js.map